import React from 'react'

import { Footer } from '../../../../common/footer/footer';
import clipboard from "../../../../../assets/askTheExpertImages/clipboard.svg";
import { NEW_URL } from '../../../../../constants/applicationConstants';
import "../../customerAskTheExpert/customerAskTheExpert.css";
import { getIconOne } from '../customerAskTheExpert.jsx';


const ConfirmAskTheExpertJsx = (props) => {
  const {
    category,    
    subCategory,    
    question,    
    onConfirmAndSubmitButtonClick,
    closeModalEdit,icon
  } = props;

  return (
    <>
       <div className="modalspecial asktheexpertconfirmpopup popupouter">
        <div>
        <div className="popupnew">
          <div className="row"><div className="col-lg-12 col-sm-12"> <h2>{question}</h2></div>
            <div className="col-lg-7 col-sm-7">
              <div className="cliparttext">
               
                <div className="clipartmain">
                  <div className="cliparttextbox">
                    <p className="text-categ">Category</p>
                    <div className="cliparttextboxinner">
                      <img src={getIconOne(category)} alt="" /></div>
                  </div>


                  {subCategory &&
                    <div className="cliparttextboxouter"> <p>Sub-Category</p>
                      <div className="cliparttextbox cliparttextboxtwo">
                        <div className="iconbase">
                          <img 
                          // src={`/${(subCategory).replace(/\s/g, '')}.png`}
                          src={`${NEW_URL}/${icon}`}

                           alt="" /></div>
                        <p>{subCategory}</p>
                      </div>
                    </div>
                  }

                </div>
                <div className="clipartbtn mt-4">
                  <button onClick={closeModalEdit} className="clipartbutton">Edit</button>
                  <button onClick={onConfirmAndSubmitButtonClick} className="clipartbutton2">Confirm & Submit</button>
                </div>
              </div>

            </div>
            <div className="col-lg-5 col-sm-5 clipart-box">
              <div className="clipart"><img src={clipboard} alt="icon" /></div>
            </div>
          </div>
        </div>
      </div>
</div>
      <Footer />
    </>

  );
};

export default ConfirmAskTheExpertJsx;